export enum FilterType {
    FREE_TEXT,
    MATCHES_ANY_OF,
    MATCHES_ALL_OF,
    RELATIVE_DATE,
    SPECIFIC_DATE,
    NUMERICAL,
    CUSTOM,
}

export enum BlueConicFilterType {
    PRODUCTS = 'products',
    CATEGORY = 'category',
    KEYWORD = 'articlekeywords',
    AUTHOR = 'author',
    SITENAME = 'sitename',
    PUBLICATION_DATE = 'publication_date',
    PROPERTY = 'has_property',
    CUSTOM = 'custom',
}

export enum ProductsFilters {
    VIEWED = 'VIEWED',
    VIEWED_ONLY = 'VIEWED_ONLY',
    SHOPPINGCART = 'SHOPPINGCART',
    SHOPPINGCART_ONLY = 'SHOPPINGCART_ONLY',
    BOUGHT = 'BOUGHT',
    BOUGHT_ONLY = 'BOUGHT_ONLY',
    SAME_CATEGORY = 'SAME_CATEGORY',
    IN_STOCK = 'IN_STOCK',
}

export enum ConditionOperatorType {
    EQUALS = 'eq',
    NOT_EQUALS = 'neq',
    LT = 'lt',
    GT = 'gt',
    LTE = 'lte',
    GTE = 'gte',
    CONTAINS = 'contains',
    NOT_CONTAINS = 'not_contains',
    BETWEEN = 'between',
    NOT_BETWEEN = 'not_between',
    DATE_IN = 'date_in',
    DATE_NOT_IN = 'date_not_in',
    ARRAY_CONTAINS = 'a_contains',
    ARRAY_NOT_CONTAINS = 'a_not_contains',
    EXISTS = 'exists',
    NOT_EXISTS = 'not_exists',
    IDS = 'ids',
    GEO_INCLUDES = 'geo_includes',
    GEO_EXCLUDES = 'geo_excludes',
    PREFIX = 'prefix',
    NOT_PREFIX = 'not_prefix',
    EQ_ANY = 'eq_any',
    NEQ_ANY = 'neq_any',
    SEMANTIC_EQUALS = 'semantic_equals',
    SEMANTIC_NOT_EQUALS = 'semantic_not_equals',
    SEMANTIC_LT = 'semantic_lt',
    SEMANTIC_GT = 'semantic_gt',
    SEMANTIC_LTE = 'semantic_lte',
    SEMANTIC_GTE = 'semantic_gte',
    SEMANTIC_BETWEEN = 'semantic_between',
    SEMANTIC_NOT_BETWEEN = 'semantic_not_between',
}
